/**
 * CardAction5 시나리오
 * 한눈에 보이는 진료정보 - action5.svg
 */

import { ReactComponent as Action5SVG } from "@/assets/animations/action5.svg";
import type { MotionScenario } from "../types";

export const cardAction5Scenario: MotionScenario = {
  svgComponent: Action5SVG,

  transitionSpeed: 2000,

  repeat: {
    mode: "once",
  },

  viewBoxAnimation: {
    duration: 800,
    easing: "easeInOut",
  },

  scenes: [
    // Scene 0: 초기 상태 (모든 Comment 숨김)
    {
      id: 0,
      name: "initial",
      elements: [
        {
          selector: 'g[data-name="Comment_Wait"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="Comment_Treatment"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="Comment_Complete"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="Comment_History"]',
          opacity: 0,
        },
      ],
    },

    // Scene 1: Comment_Wait 표시
    {
      id: 1,
      name: "comment-wait",
      elements: [
        {
          selector: 'g[data-name="Comment_Wait"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="Comment_Treatment"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="Comment_Complete"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="Comment_History"]',
          opacity: 0,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="Comment_Wait"]',
        zoom: 0.4,
      },
      glowEffect: true,
      glowSelector: 'g[data-name="Comment_Wait"]',
    },

    // Scene 2: Comment_Treatment 표시
    {
      id: 2,
      name: "comment-treatment",
      elements: [
        {
          selector: 'g[data-name="Comment_Wait"]',
          opacity: 0, // 이전 Comment 숨김
        },
        {
          selector: 'g[data-name="Comment_Treatment"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="Comment_Complete"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="Comment_History"]',
          opacity: 0,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="Comment_Treatment"]',
        zoom: 0.4,
      },
      glowEffect: true,
      glowSelector: 'g[data-name="Comment_Treatment"]',
    },

    // Scene 3: Comment_Complete 표시
    {
      id: 3,
      name: "comment-complete",
      elements: [
        {
          selector: 'g[data-name="Comment_Wait"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="Comment_Treatment"]',
          opacity: 0, // 이전 Comment 숨김
        },
        {
          selector: 'g[data-name="Comment_Complete"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="Comment_History"]',
          opacity: 0,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="Comment_Complete"]',
        zoom: 0.4,
      },
      glowEffect: true,
      glowSelector: 'g[data-name="Comment_Complete"]',
    },

    // Scene 4: Comment_History 표시
    {
      id: 4,
      name: "comment-history",
      elements: [
        {
          selector: 'g[data-name="Comment_Wait"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="Comment_Treatment"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="Comment_Complete"]',
          opacity: 0, // 이전 Comment 숨김
        },
        {
          selector: 'g[data-name="Comment_History"]',
          opacity: 1,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="Comment_History"]',
        zoom: 0.4,
      },
      glowEffect: true,
      glowSelector: 'g[data-name="Comment_History"]',
    },
  ],
};
